import * as React from 'react';
import * as styles from './styles.css';

import { UIHeading4, UIText2, Button, Responsive, ModalWindow } from '@cian/ui-kit';
import { IconFunctionalWarningCircle24 } from '@cian/ui-kit-design-tokens/icons';
import { ConditionalWrapper } from '@cian/conditional-component';
import { CulturalHeritage } from '../CulturalHeritage';

export enum EWarningMoreInfoType {
  culturalHeritage = 'culturalHeritage',
}

interface IWarningMoreInfo {
  title: string;
  type: EWarningMoreInfoType;
}

export interface IWarningBannerProps {
  isDesktop: boolean;
  title: string;
  text: string;
  moreInfo?: IWarningMoreInfo;
}

const moreInfoMapper = {
  [EWarningMoreInfoType.culturalHeritage]: <CulturalHeritage />,
};

export const WarningBanner: React.FC<IWarningBannerProps> = ({ isDesktop, title, text, moreInfo }) => {
  const [moreInfoOpened, setMoreInfoOpened] = React.useState(false);

  const toggleMoreInfoOpened = React.useCallback(() => {
    setMoreInfoOpened(!moreInfoOpened);
  }, [moreInfoOpened]);

  return (
    <div data-testid="AboutHome_WarningBanner" className={styles['container']}>
      <div className={styles['text-content']}>
        <Responsive phone tablet>
          <div className={styles['icon']}>
            <IconFunctionalWarningCircle24 color="icon-warning-default" />
          </div>
        </Responsive>
        <div className={styles['content']}>
          <div className={styles['title']}>
            <UIHeading4 color="text-primary-default">{title}</UIHeading4>
          </div>
          <UIText2 color="text-primary-default">{text}</UIText2>
        </div>
      </div>
      {moreInfo && (
        <>
          <button
            data-testid="WarningBanner_more_info"
            type="button"
            className={styles['more-info']}
            onClick={toggleMoreInfoOpened}
          >
            <ConditionalWrapper
              if={isDesktop}
              ThenComponent={UIText2}
              ElseComponent={UIHeading4}
              color="accent-main-primary"
            >
              Подробнее
            </ConditionalWrapper>
          </button>
          <ModalWindow
            open={moreInfoOpened}
            onClose={toggleMoreInfoOpened}
            size="M"
            fixed
            width={680}
            title={moreInfo.title}
            footer={
              <div data-testid="WarningBanner_more_info_btn" className={styles['more-info-footer']}>
                <Button theme="fill_primary" onClick={toggleMoreInfoOpened}>
                  Ок, понятно
                </Button>
              </div>
            }
            content={moreInfoMapper[moreInfo.type]}
          />
        </>
      )}
    </div>
  );
};

WarningBanner.displayName = 'WarningBanner';
